/* eslint-disable */
import NoBond from '../../assets/images/nodata.svg'
import { Button } from '../ui/button'
import { useNavigate } from 'react-router-dom'

const SIPsEmpty = ({ title, description, mainText, page, showButton }) => {
  const navigate = useNavigate()
  return (
    <div
      className='py-12'
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '12px',
      }}
    >
      <img src={NoBond} width={400} alt='No Bond' />

      <div
        style={{
          // width: '454px',
          gap: '4px',
          textAlign: 'center',
        }}
      >
        <p
          style={{
            fontSize: '20px',
            fontWeight: 600,
            lineHeight: '28px',
            letterSpacing: '-0.04em',
            fontFamily: 'DM Sans',
            marginTop: '30px',
            marginBottom: '4px',
            color: '#2D2D2D',
          }}
        >
          {title}
        </p>

        <p
          style={{
            fontFamily: 'DM Sans',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            marginBottom: '12px',
            color: 'black-300',
          }}
        >
          {description}
          {/* <span
            style={{
              fontFamily: 'DM Sans',
              fontSize: '16px',
              fontWeight: 500,
              lineHeight: '24px',
              color: '#2D2D2D',
            }}
          >
            {mainText}
          </span> */}
        </p>

        {showButton && <Button onClick={() => navigate(page)}>Discover Top Funds </Button>}
      </div>
    </div>
  )
}

export default SIPsEmpty
